import { render } from "./LocalidadesTabPage.vue?vue&type=template&id=2a0bfc7c"
import script from "./LocalidadesTabPage.vue?vue&type=script&lang=js"
export * from "./LocalidadesTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__